import { motion } from "framer-motion";
import { Button } from "../components/ui/button";

const About = () => {
  const scrollToSection = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="about" className="bg-white py-24 lg:py-32 overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left — Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="aspect-square bg-light-grey p-12 flex items-center justify-center shadow-lg border border-charcoal/10">
              <img
                src="https://customer-assets.emergentagent.com/job_mheshe-legal/artifacts/1xa23sin_Mheshe%20Attorneys.png"
                alt="Mheshe Attorneys Logo"
                className="max-w-full h-auto"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-20 h-20 bg-brand-gold hidden lg:block" />
          </motion.div>

          {/* Right — Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
              Our Approach
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl font-semibold text-charcoal leading-tight tracking-tighter mb-8">
              Depth of Expertise and Clarity of Purpose
            </h2>
            <div className="space-y-6 text-charcoal/70 font-sans text-lg leading-relaxed">
              <p>
                We do not seek to practise in every area of law. Our focus is deliberately built around property development, specialist conveyancing, notarial practice and the commercial, governance and dispute-resolution services that support complex property and business transactions.
              </p>
            </div>
            <div className="mt-10">
              <Button
                onClick={() => scrollToSection("#services")}
                className="btn-gold px-8 py-4 text-base font-semibold uppercase tracking-wider rounded-none"
                data-testid="about-explore-btn"
              >
                Explore Our Expertise
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
